module.exports = __webpack_public_path__ + "img/about_bg.3f94c04f.jpg";